import type { ModuleGate } from '@/shell/model/module-catalog';

/** Both open to org members (#788); the API re-checks. */
export const ARCHIVE_OVERVIEW_READ = 'archivio:panoramica:read';
export const ARCHIVE_RULES_READ = 'archivio:regole:read';

/** The rail entry's rule: the module shows when either page is open to the caller. */
export const ARCHIVE_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [ARCHIVE_OVERVIEW_READ, ARCHIVE_RULES_READ],
};
